import React, { PropsWithChildren } from 'react';
import AuthenticationCardLogo from '@/Components/AuthenticationCardLogo';
import PrimaryButton from '@/Components/PrimaryButton';
import { cn } from '@/utils';

interface Props {
  childrenPlacement?: 'top' | 'bottom';
}

export default function AuthLayout({ children }: PropsWithChildren<Props>) {
  return (
    <div
      className={cn(
        'dark flex w-screen flex-col-reverse overflow-auto bg-brand-dark-100 md:h-screen lg:flex-row'
      )}
    >
      <Panel
        className="relative bg-[url('../images/authbg.png')] bg-cover bg-bottom bg-no-repeat"
        innerClassName="lg:max-w-none h-full flex flex-col justify-between"
      >
        <div>
          <AuthenticationCardLogo />
          <h1 className="pt-12 font-sans text-xl font-semibold leading-none text-white xl:text-xxl">
            Welcome <br /> to CodeWP
          </h1>
          <p className="pt-4 text-lg font-medium text-white xl:text-xl">
            AI Tools For WordPress creators. Code, Chat, and Troubleshoot.
          </p>
        </div>
        <div>
          <p className="pb-8 pr-20  text-white">
            Generate plugins, troubleshoot code, and accelerate your workflow
            with an AI assistant customized for WordPress. Choose expert modes
            for reliable generations. Leverage real-time conversations to learn
            or get unstuck. Take the grunt work out and spend time on what
            matters most - creating incredible websites.
          </p>
          <small className="text-sm text-brand-light-25">
            © {new Date().getFullYear()} WPAI, Inc. All rights reserved. CodeWP
            and its logo are registered trademarks of WPAI, Inc.
          </small>
        </div>
      </Panel>

      <Panel>{children}</Panel>
    </div>
  );
}

function Panel({
  children,
  className,
  innerClassName,
  ...props
}: {
  children: React.ReactNode;
  className?: string;
  innerClassName?: string;
}) {
  return (
    <div
      className={cn(
        'flex items-center justify-center p-12 lg:w-1/2 lg:p-20',
        className
      )}
      {...props}
    >
      <div className={cn('w-full max-w-md', innerClassName)}>{children}</div>
    </div>
  );
}

export function AuthPrimaryButton({
  className,
  children,
  ...props
}: PropsWithChildren<{
  disabled: boolean;
  className?: string;
}>) {
  return (
    <PrimaryButton
      className={cn(
        'flex w-full justify-center text-center capitalize disabled:dark:bg-brand-dark-50 disabled:dark:text-brand-light-25 disabled:hover:dark:text-brand-light-50',
        className
      )}
      {...props}
    >
      {children}
    </PrimaryButton>
  );
}
